import "@/index.css";

export const Branding = (): JSX.Element => (
  <div className="inline-flex items-center font-branding text-2xl font-semibold text-red-secondary">
    h:
  </div>
);

export default Branding;
